import axios from 'axios'
import md5 from 'crypto-js/md5'
import { randomWord, getDeviceInfo } from './utils/common'
import Toast from '@common/toast'
import Loading from '@common/loading'

export const isProd = /^m\.feidee|^operation\.feidee|yunres\.|yunuatres\./.test(window.location.hostname)

const getClientKey = () => {
  if (isProd) {
    return '520BFC1EA31D45678A9B865668A47F40'
    // ClientSecret = '910A796A77E0433B96E741D238C9C744'
  } else {
    return 'FDAFF8BBD6714A8DB5AF9BB0BEAD8A03'
    // let ClientSecret = '718ABA3AC58D43919176A2748B830A51'
  }
}

/**
 *
 * @param {String} clientKey 客户端登录key值
 * @param {String} timestamp 随机字符串
 * @param {String} nonceStr 随机串
 */
export const sign = (clientKey, timestamp, nonceStr = randomWord(false, 32), clientSecret = '') => {
  return {
    sign: md5(clientKey + nonceStr + timestamp + clientSecret).toString(),
    nonceStr
  }
}

export const deviceInfo = getDeviceInfo()

/**
 * 获取公共headers
 * @returns
 */
export const defaultHeaders = (clientKeyStr) => {
  const timestamp = new Date().getTime()
  const ClientKey = clientKeyStr || getClientKey()
  const auth = sign(ClientKey, timestamp)

  return {
    'Content-Type': 'application/json',
    'Client-Key': ClientKey,
    'Minor-Version': 2,
    'Nonce-Str': auth.nonceStr,
    Timestamp: timestamp.toString(),
    Type: 'MD5-H5',
    Sign: auth.sign,
    Device: deviceInfo,
    'App-Id': 'SSJ-H5',
  }
}

export const request = (option, method = 'get') => {
  return new Promise((resolve, reject) => {
    const { url, body, header, showError, errorMsg, showLoading } = { showError: true, showLoading: true, ...option }
    const config = {}

    if (method === 'post') {
      config.data = body
    } else {
      config.params = body
    }

    showLoading && Loading.show()

    axios.request({
      method,
      url,
      ...config,
      timeout: 10000,
      withCredentials: ['dev'].indexOf(process.env.NODE_ENV) === -1,
      headers: {
        ...defaultHeaders(),
        ...header
      }
    })
      .then((response) => {
        Loading.hide()
        resolve(response.data)
      }).catch((error) => {
        const response = error.response || {}
        showLoading && Loading.hide()

        if (response.data && response.data.message) {
          error.msg = response.data.message
        } else if (error.message.indexOf('timeout') !== -1) {
          error.msg = '数据请求超时，请稍后再试~'
        } else if (error.message.indexOf('Network Error') !== -1) {
          error.msg = '世界上最遥远的距离，就是没有网络~'
        } else {
          error.msg = errorMsg || error.message || error.msg || '太火爆了，请稍等几分钟后再次进入活动页重试'
        }

        showError && Toast(error.msg)
        reject(error)
      })
  })
}
